import { render, staticRenderFns } from "./NordArticlePage.vue?vue&type=template&id=0fabe03a&"
import script from "./NordArticlePage.vue?vue&type=script&lang=js&"
export * from "./NordArticlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fabe03a')) {
      api.createRecord('0fabe03a', component.options)
    } else {
      api.reload('0fabe03a', component.options)
    }
    module.hot.accept("./NordArticlePage.vue?vue&type=template&id=0fabe03a&", function () {
      api.rerender('0fabe03a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/NordArticlePage.vue"
export default component.exports